type StorageType = 'localStorage' | 'sessionStorage';

const createStorageUtil = (
  storageType: StorageType,
  prefix: string = 'odin_',
) => {
  const storage =
    storageType === 'localStorage' ? localStorage : sessionStorage;

  const getPrefixedKey = (key: string): string => `${prefix}${key}`;

  return {
    getItem: <T>(key: string): T | null => {
      const item = storage.getItem(getPrefixedKey(key));
      return item ? (JSON.parse(item) as T) : null;
    },
    setItem: (key: string, value: unknown): void => {
      try {
        const serialized = JSON.stringify(value);
        storage.setItem(getPrefixedKey(key), serialized);
      } catch (error) {
        console.error(
          `Error storing key "${key}" in ${storageType}:`,
          error,
          value,
        );
      }
    },
    removeItem: (key: string): void => {
      storage.removeItem(getPrefixedKey(key));
    },
    clearAllWithPrefix: (): void => {
      const keysToRemove: string[] = [];
      for (let i = 0; i < storage.length; i++) {
        const key = storage.key(i);
        if (key && key.startsWith(prefix)) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach((key) => storage.removeItem(key));
    },
  };
};

// Initialize with localStorage and prefix 'odin_'
export const storageUtil = createStorageUtil('localStorage', 'odin_');

export const sessionStorageUtil = createStorageUtil('sessionStorage', 'odin_');
